import React, { useState } from "react";
import { Monitor, Smartphone } from "lucide-react";

/**
 * DevicePreviewIframe — Vista previa de email con switch Desktop/Mobile.
 *
 * Props:
 *  - srcDoc: string — HTML completo a renderizar dentro del iframe.
 *  - testIdPrefix: string — prefijo para data-testids (ej: "outbound-preview").
 *  - height: number — alto en px (default 460).
 *  - headerSlot: ReactNode (opcional) — contenido encima del iframe (ej: Para/Asunto).
 *  - initialDevice: 'desktop' | 'mobile' — device inicial (default 'desktop').
 *  - className: string — clases extras para el contenedor raíz.
 */
export default function DevicePreviewIframe({
  srcDoc,
  testIdPrefix,
  height = 460,
  headerSlot = null,
  initialDevice = "desktop",
  className = "",
}) {
  const [device, setDevice] = useState(initialDevice);
  const isMobile = device === "mobile";
  return (
    <div className={className} data-testid={`${testIdPrefix}-device-frame`}>
      <div className="flex items-center justify-end mb-2">
        <div className="inline-flex border border-gray-300 rounded-sm bg-white">
          <button
            type="button"
            onClick={() => setDevice("desktop")}
            className={`px-2.5 py-1 text-xs inline-flex items-center gap-1 transition-colors ${
              !isMobile ? "bg-brand-burgundy text-white" : "text-gray-700 hover:bg-gray-50"
            }`}
            data-testid={`${testIdPrefix}-device-desktop`}
          >
            <Monitor size={13} /> Desktop
          </button>
          <button
            type="button"
            onClick={() => setDevice("mobile")}
            className={`px-2.5 py-1 text-xs inline-flex items-center gap-1 transition-colors ${
              isMobile ? "bg-brand-burgundy text-white" : "text-gray-700 hover:bg-gray-50"
            }`}
            data-testid={`${testIdPrefix}-device-mobile`}
          >
            <Smartphone size={13} /> Móvil
          </button>
        </div>
      </div>
      <div className={`mx-auto transition-all ${isMobile ? "max-w-[375px]" : "max-w-full"}`}>
        {headerSlot && (
          <div className="border border-b-0 border-gray-200 px-3 py-2 bg-gray-50 rounded-t-sm">
            {headerSlot}
          </div>
        )}
        <iframe
          title={`${testIdPrefix}-body`}
          srcDoc={srcDoc}
          className={`w-full border border-gray-200 bg-white ${headerSlot ? "rounded-b-sm border-t-0" : "rounded-sm"}`}
          style={{ height }}
          sandbox="allow-popups allow-popups-to-escape-sandbox"
        />
      </div>
    </div>
  );
}
